import { Phone } from 'lucide-react';
import { Button } from './ui/button';

interface HeaderProps {
  onQuoteClick: () => void;
}

export function Header({ onQuoteClick }: HeaderProps) {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-border">
      <div className="container mx-auto px-4 h-16 flex items-center justify-between">
        {/* Logo */}
        <div className="flex items-center">
          <span className="font-medium text-lg">NY Glass</span>
        </div>

        {/* Phone - Center on desktop, hidden on mobile */}
        <a
          href="tel:6468999891"
          className="hidden md:flex items-center gap-2 hover:opacity-70 transition-opacity"
        >
          <Phone className="w-4 h-4" />
          <span>646-899-9891</span>
        </a>

        {/* CTA Button */}
        <Button onClick={onQuoteClick} className="bg-primary hover:bg-primary/90">
          <span className="hidden sm:inline">Get Instant Quote</span>
          <span className="sm:hidden">Quote</span>
        </Button>
      </div>
    </header>
  );
}
